import { Checkmark } from '@/components/Checkmark';
import Logo from '@/components/Logo';
import type { LogoVariant } from '@/components/LogoVariant';
import classnames from '@/utilities/classnames';
import numberToCurrency from '@/utilities/numberFormatter';
import replaceAbbreviations from '@/utilities/replaceAbbreviations';

export const AdditionalGame = ({
  checked,
  jackpotLabelPrefix,
  color,
  additionalGameId,
  onChange,
  disabled,
  title,
  jackpotLabel,
  jackpotLabelSuffix,
  chanceDesc,
  logoColor,
  price,
}: {
  checked: boolean;
  color?: string;
  disabled?: boolean;
  additionalGameId?: number;
  onChange: (id: number) => void;
  title: string;
  jackpotLabel?: string;
  jackpotLabelPrefix?: string;
  jackpotLabelSuffix?: string;
  chanceDesc?: string;
  logoColor?: LogoVariant;
  price?: number;
}) => {
  const htmlId = 'additional-game-' + additionalGameId;
  // space replacement GlücksSpirale is quite ugly...
  const jackpot = [jackpotLabelPrefix, jackpotLabel, jackpotLabelSuffix]
    .filter((s) => !!s)
    .join('<br />&nbsp;')
    .replace(
      /(&nbsp;)?<nospace>(&nbsp;)?([^<&]+)(&nbsp;)?<\/nospace>/,
      '$3&thinsp;*'
    )
    .replace(/&nbsp;&nbsp;/g, '&nbsp;');

  return (
    <>
      <div
        className={classnames('AdditionalGame', {
          'AdditionalGame--checked': checked,
          'AdditionalGame--disabled': disabled,
        })}
      >
        {
          <input
            id={htmlId}
            type="checkbox"
            checked={checked}
            disabled={disabled}
            onChange={() => additionalGameId && onChange(additionalGameId)}
            className="AdditionalGame__input"
          />
        }
        {title && (
          <label
            htmlFor={htmlId}
            id={`${htmlId}-label`}
            style={{ color }}
            className="AdditionalGame__label"
            title={title}
            tabIndex={0}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                if (additionalGameId) {
                  onChange(additionalGameId);
                }
              }
            }}
          >
            <Checkmark checked={checked} />
            {logoColor && (
              <span
                className={`AdditionalGame__logo AdditionalGame__logo-${additionalGameId}`}
              >
                <Logo variant={logoColor} />
              </span>
            )}
            <span className="AdditionalGame__description">
              <span
                className="AdditionalGame__jackpot"
                dangerouslySetInnerHTML={replaceAbbreviations(jackpot)}
              />
              <small className="AdditionalGame__chanceDesc">
                {chanceDesc && (
                  <span
                    dangerouslySetInnerHTML={replaceAbbreviations(chanceDesc)}
                  />
                )}
                {logoColor === 'logo-gluecksspirale-color' && (
                  <>
                    <br />{' '}
                    <span
                      dangerouslySetInnerHTML={replaceAbbreviations(
                        'Teilnahme am Sa.'
                      )}
                    />
                  </>
                )}
                {additionalGameId === 4 && <p>* 20 Jahre lang</p>}
              </small>
            </span>
            <div className="AdditionalGame__priceContainer">
              <span className="AdditionalGame__price">
                {price && numberToCurrency(price)}
              </span>
              <span className="AdditionalGame__perDraw">pro&nbsp;Ziehung</span>
            </div>
          </label>
        )}
      </div>
    </>
  );
};
